import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "MeetingsModule"
const debug = false

export class MeetingsModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.MEETINGS, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Meetings"
        this.description                = "The Meetings module offers a robust suite of features for efficient meeting management. Users can plan meetings, create agendas, manage action items, document meeting notes, and more. With customizable settings and intuitive tools, this module streamlines the entire meeting process, enhancing productivity and collaboration within your workspace."
        this.svgIcon                    = "isvg-view-meetings"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Productivity & Collaboration"
        this.settingsUrl                = "settings/meetings"

        this.parentSection              = SettingsParentSection.PRODUCTIVITY
    }

    enable():void {
        super.enable()

        // gd.layout.left?.reRender()
        gd.layout.navigation.reset()
        gd.layout.navigation.reRender()
    }

    disable():void {
        super.disable()

        // gd.layout.left?.reRender()
        gd.layout.navigation.reset()
        gd.layout.navigation.reRender()
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}